import { Injectable, RendererFactory2, Renderer2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeFileSwitcherService {
    private renderer: Renderer2;

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    switchTheme(theme: string): void {
        const themeLink = document.getElementById('theme-css') as HTMLLinkElement;

        if (theme === 'dark') {
            themeLink.href = 'assets/theming/smarthink-dark/theme.css';
        } else {
            themeLink.href = 'assets/theming/smarthink-light/theme.css';
        }

        localStorage.setItem('appTheme', theme);
    }
}
